import { AxiosHttpClient } from '@va/api-client';
import { AxiosRequestConfig } from 'axios';
import * as Config from 'Config';
import { stream } from 'fetch-event-stream';
import { isEmpty } from 'lodash';

class AiApiClient extends AxiosHttpClient {
  private static apiClientInstance?: AiApiClient;

  private constructor() {
    super(`${Config.aiApiUrl}/`);
  }

  public static getInstance() {
    if (!this.apiClientInstance) {
      this.apiClientInstance = new AiApiClient();
    }
    return this.apiClientInstance;
  }

  public get = async <T = unknown>(url: string, config?: AxiosRequestConfig) => {
    const response = await this.instance.get<T>(url, config);
    return response.data;
  };

  public post = async <T = unknown>(url: string, data?: {}, config?: AxiosRequestConfig) => {
    const response = await this.instance.post<T>(url, data, config);
    return response.data;
  };

  public postToStream = async (url: string, data?: {}, config?: Record<string, any>) => {
    return stream(`${Config.aiApiUrl}${url}`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${this.token}`,
        'Content-Type': 'application/json',
        'X-Timezone': window.timezone ?? Intl.DateTimeFormat().resolvedOptions().timeZone,
      },
      body: JSON.stringify(data),
      signal: config?.signal,
    });
  };

  public put = async <T = unknown>(url: string, data: {}, config?: AxiosRequestConfig) => {
    const response = await this.instance.put<T>(url, data, config);
    return response.data;
  };

  public patch = async <T = unknown>(url: string, data: {}, config?: AxiosRequestConfig) => {
    const response = await this.instance.patch<T>(url, data, config);
    return response.data;
  };

  public delete = async <T = unknown>(url: string, data: {} = {}, config?: AxiosRequestConfig) => {
    const response = await this.instance.delete<T>(url, !isEmpty(data) ? { data, ...config } : config);
    return response.data;
  };
}

export const aiApiClient = AiApiClient.getInstance();
